import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginService } from './login.service';

@Component( {
    selector: 'p-login',
    templateUrl: 'login.component.html'
} )
export class LoginComponent implements OnInit {

    public email: string;
    public password: string;
    public message: string;

    constructor( private loginService: LoginService ) {
        this.message = ""
        this.email = "admin-25"
        this.password = "admin*01"
    }
    
    ngOnInit() { }

    // TODO: Remove this when we're done
    get diagnostic() { return JSON.stringify( this ); }

    private onSubmit() {
        //console.log(JSON.stringify(this));		
        console.log( "On submit" );
        this.loginService.login( this.email, this.password, ( error, msg ) => {
            if ( error ) this.message = "Identifiant ou mot de passe invalide"
        } );
    }

    private onAction(): void { }

    private handleError( error: any ) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = ( error.message ) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error( errMsg ); // log to console instead
        return Observable.throw( errMsg );
    }
}